import React, {useState} from 'react'
import {Breadcrumb, Button, Row, Col, Form} from 'react-bootstrap'
import {useQuery} from '@apollo/client'
import {GET_CONTACT_SEGMENTS} from '../../gql/queries/segments'
import {RecipientFilters} from './components/RecipientFilters'
import {RecipientList} from './components/RecipientList'
import {TagManager} from './components/TagManager'
import {SegmentManager} from './components/SegmentManager'
import {AddRecipientsModal} from './components/AddRecipientsModal'
import {RecipientFilters as FilterTypes, RecipientStats} from './recipientsTypes'
import './RecipientsPage.css'

export const RecipientsPage: React.FC = () => {
  const [filters, setFilters] = useState<FilterTypes>({
    search: '',
    status: 'ALL',
    tags: [],
    segment: '',
  })

  const [selectedContactIds, setSelectedContactIds] = useState<string[]>([])
  const [showTagManager, setShowTagManager] = useState(false)
  const [showSegmentManager, setShowSegmentManager] = useState(false)
  const [showAddRecipients, setShowAddRecipients] = useState(false)
  const [stats, setStats] = useState<RecipientStats | undefined>(undefined)

  const {data: segmentsData} = useQuery(GET_CONTACT_SEGMENTS)
  const segments = segmentsData?.contactSegments || []

  // Removed separate stats query as it's now included in RecipientList query

  const handleFilterChange = (newFilters: Partial<FilterTypes>) => {
    setFilters(prev => ({...prev, ...newFilters}))
  }

  const handleSelectionChange = (contactIds: string[]) => {
    setSelectedContactIds(contactIds)
  }

  return (
    <div className='recipients-page'>
      <header className='header'>
        <div className='d-flex align-items-center gap-3'>
          <Breadcrumb className='mb-0'>
            <Breadcrumb.Item className='fs-3'>Recipients</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className='d-flex align-items-center gap-2'>
          <Form.Select
            size='sm'
            style={{width: '200px'}}
            value={filters.segment}
            onChange={(e) => handleFilterChange({segment: e.target.value})}
          >
            <option value=''>All Segments</option>
            {segments.map((seg: any) => (
              <option key={seg.id} value={seg.id}>
                {seg.name}
              </option>
            ))}
          </Form.Select>

          <Button variant='outline-secondary' size='sm' onClick={() => setShowTagManager(true)}>
            <i className='bi bi-tags me-2'></i>
            Manage Tags
          </Button>
          <Button variant='outline-secondary' size='sm' onClick={() => setShowSegmentManager(true)}>
            <i className='bi bi-diagram-3 me-2'></i>
            Manage Segments
          </Button>
          <Button variant='outline-primary' size='sm'>
            <i className='bi bi-file-earmark-arrow-down me-2'></i>
            Export CSV
          </Button>
          <Button variant='success' size='sm' onClick={() => setShowAddRecipients(true)}>
            <i className='bi bi-person-plus me-2'></i>
            Add Recipients
          </Button>
        </div>
      </header>

      <Row className='recipients-content'>
        <Col md={3} lg={3} sm={12} className='filters-sidebar'>
          <RecipientFilters
            filters={filters}
            onFilterChange={handleFilterChange}
            stats={stats}
          />
        </Col>

        <Col md={9} lg={9} sm={12} className='recipients-main'>
          <RecipientList
            filters={filters}
            setFilters={setFilters}
            selectedContactIds={selectedContactIds}
            onSelectionChange={handleSelectionChange}
            segmentId={filters.segment}
            onStatsChange={setStats}
          />
        </Col>
      </Row>

      {/* Tag Manager Modal */}
      <TagManager
        show={showTagManager}
        onHide={() => setShowTagManager(false)}
        onTagsUpdated={() => {
          // Refresh the list when tags are updated
        }}
      />

      {/* Segment Manager Modal */}
      <SegmentManager
        show={showSegmentManager}
        onHide={() => setShowSegmentManager(false)}
        onSegmentsUpdated={() => {
          // Refresh when segments are updated
        }}
      />

      {/* Add Recipients Modal */}
      <AddRecipientsModal
        show={showAddRecipients}
        onHide={() => setShowAddRecipients(false)}
        onSuccess={() => {
          // Refresh recipients list when new ones are added
          window.location.reload() // Simple refresh for now
        }}
      />
    </div>
  )
}
